import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { colors } from '@skyslope/mache';
import { FileStatus, type IFile } from '../../types';

const useStyles = makeStyles(() => ({
  status: {
    width: 'fit-content',
    borderRadius: '4px',
  },
  statusText: {
    color: '#FFFFFF',
    padding: '0 8px',
  },
}));

interface IProps {
  file: IFile;
}

const STATUS_COLORS = {
  [FileStatus.Active]: colors.grey[800],
  [FileStatus.Expired]: '#D20004',
  [FileStatus.Incomplete]: '#6E2EB9',
  [FileStatus.Pending]: '#FFAB00',
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const PropertyStatus = (props: IProps) => {
  const classes = useStyles();
  return (
    <div
      className={classes.status}
      style={{ backgroundColor: STATUS_COLORS[props.file.status] }}
      data-spec="file-status"
    >
      <Typography variant="overline" className={classes.statusText}>
        {props.file.status}
      </Typography>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default PropertyStatus;
